export const SocketEvents = {
    liveStream:"live_stream",
    liveIndexing:"event_indexing",
    trackEventDelay:"event_delay",
    EventCrud: "event_crud",
    EventEnded:"event_ended",
    EventStarted:"event_started"

}